import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowLeft, Sparkles } from "lucide-react";
import { Button } from "../components/ui/button";
import { tiktokTrack, tiktokIdentify } from "../lib/tiktokPixel";

const ThankYou = () => {
  const [params] = useSearchParams();
  const plan = params.get("plan") || "";
  const priceRaw = params.get("price");
  const price = priceRaw ? parseFloat(priceRaw) : null;
  const email = params.get("email") || "";
  const phone = params.get("phone") || "";

  useEffect(() => {
    // 1) Identify the user first so TikTok can hash-match this conversion
    //    to the person who saw / clicked the ad (Automatic Advanced Matching).
    //    TikTok hashes email/phone on the client automatically (SHA-256).
    tiktokIdentify({
      email,
      phone_number: phone,
      external_id: email || undefined,
    });

    // 2) Then fire the conversion event.
    tiktokTrack("CompletePayment", {
      content_id: plan || "unknown",
      content_name: plan || "Program",
      content_type: "product",
      quantity: 1,
      currency: "USD",
      value: price || 0,
    });
  }, [plan, price, email, phone]);

  return (
    <div
      data-testid="thank-you-page"
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-100 via-purple-100 to-blue-100 p-4"
    >
      <div className="max-w-lg w-full bg-white rounded-3xl shadow-2xl border-4 border-purple-300 p-10 text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-green-300 to-green-400 flex items-center justify-center shadow-lg">
          <CheckCircle2 className="h-11 w-11 text-white" strokeWidth={2.5} />
        </div>

        <div className="inline-flex items-center gap-2 bg-purple-50 border-2 border-purple-200 px-3 py-1 rounded-full mb-4">
          <Sparkles className="h-3.5 w-3.5 text-purple-600" />
          <span className="text-xs font-bold text-purple-700">Payment confirmed</span>
        </div>

        <h1 className="text-3xl md:text-4xl font-extrabold text-purple-700 mb-3">
          Thank you! 🎉
        </h1>
        <p className="text-base text-gray-700 leading-relaxed mb-2">
          Your enrollment is confirmed. Welcome to <strong className="text-purple-700">Hola Spanglish</strong>!
        </p>

        {plan && (
          <div className="mt-6 mb-6 bg-gradient-to-r from-pink-50 to-purple-50 rounded-2xl p-4 border-2 border-purple-200">
            <p className="text-xs text-purple-500 font-bold uppercase tracking-wider mb-1">Your program</p>
            <p className="text-lg font-bold text-purple-700">{plan}</p>
            {price && (
              <p className="text-sm text-gray-600 mt-1">USD {price.toLocaleString()}</p>
            )}
          </div>
        )}

        <p className="text-sm text-gray-600 mb-8">
          Johana will contact you within 24 hours to schedule your first session.
          In the meantime, get ready — your Spanish journey starts now.
        </p>

        <Link to="/">
          <Button
            data-testid="thank-you-back-home"
            className="bg-gradient-to-r from-pink-300 via-purple-300 to-blue-300 hover:from-pink-400 hover:to-blue-400 text-purple-800 font-bold px-8 py-6 text-base rounded-full border-3 border-purple-300 shadow-lg hover:scale-105 transition-all duration-300"
          >
            <ArrowLeft className="mr-2 h-5 w-5" />
            Back to home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
